import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-space-grotesk font-bold text-lg rounded-xl transition-colors duration-200';
  const variants = {
    primary: 'bg-primary text-black hover:bg-primaryHover shadow-[0_0_20px_rgba(249,168,212,0.3)] hover:shadow-[0_0_30px_rgba(249,168,212,0.5)]',
    secondary: 'bg-surface2 text-white hover:bg-zinc-800 border border-zinc-700'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} px-8 py-4 ${className}`;
  if (href) {
    const isHashLink = href.startsWith('#');
    return <motion.a href={href} target={isHashLink ? undefined : '_blank'} rel={isHashLink ? undefined : 'noopener noreferrer'} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={combinedClassName} data-id="element-468">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={combinedClassName} {...props} data-id="element-469">
      {children}
    </motion.button>;
}